export default {
  meta: {
    public: false,
    auth: true,
    icon: "fa-user",
    expanded: false,
    label: "Administrator",
    permission: [
      config.permission.ADMINISTRATION_INDEX
    ]
  },
  children: [
    {
      name: "account_index",
      path: "/admin/account",
      meta: {
        label: "Accounts",
        breadcrumb: [{ name: "Accounts" }],
        permission: [config.permission.ACCOUNTS_INDEX]
      },
      component: () => import("views/admin/account/index")
    },
    {
      name: "account_create",
      path: "/admin/account/create",
      meta: {
        auth: true,
        breadcrumb: [
          { name: "Accounts", link: "/admin/account" },
          { name: "Create" }
        ],
        label: "Create"
      },
      component: () => import("views/admin/account/create")
    },
    {
      name: "account_edit",
      path: "/admin/account/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Accounts", link: "/admin/account" }]
      },
      component: () => import("views/admin/account/edit"),
      props: true
    },
    {
      name: "role_index",
      path: "/admin/role",
      meta: {
        label: "Roles",
        permission: [config.permission.ROLES_INDEX],
        breadcrumb: [{ name: "Roles" }]
      },
      component: () => import("views/admin/role/index")
    },
    {
      name: "role_create",
      path: "/admin/role/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [{ name: "Roles", link: "/admin/role" }, { name: "Create" }]
      },
      component: () => import("views/admin/role/create")
    },
    {
      name: "role_edit",
      path: "/admin/role/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Roles", link: "/admin/role" }]
      },
      component: () => import("views/admin/role/edit"),
      props: true
    },
    {
      name: "permission",
      path: "/admin/permission",
      meta: {
        auth: true,
        label: "Permissions",
        breadcrumb: [{ name: "Permissions" }],
        permission: [config.permission.PERMISSIONS_INDEX]
      },
      component: () => import("views/permission/index")
    },
    {
      name: "audit_logs",
      path: "/admin/logs",
      meta: {
        auth: true,
        label: "Audit Logs",
        breadcrumb: [{ name: "Audit Logs" }],
        permission: [config.permission.LOGS_INDEX]
      },
      component: () => import("views/auditlogs/logs")
    }
  ]
};
